import React from "react";
import "./Miscellaneous.scss";

// Types
import { CurrentSegmentComponentProps } from "../SettingsTypes";

// Hooks
import { useTranslation } from "react-i18next";

// Components
import { faChartMixed } from "@fortawesome/pro-regular-svg-icons";
import { IonLabel } from "@ionic/react";
import SubTitle from "../../../../components/Admin/Settings/SubTitle";
import { InputFactory } from "../../../../components/Factories/Input";

export default function MiscellaneousSegment(props: CurrentSegmentComponentProps) {
  const { t } = useTranslation();
  const { formData, updateFormData, errors } = props;

  return (
    <div className="page--admin--settings--miscellaneous">
      <section>
        <SubTitle text={t("analytics")} icon={faChartMixed} />
        <h3>{t("googleAnalyticsTrackingId")}</h3>

        <div>
          <IonLabel>{t("googleAnalyticsTrackingIdExplainer")}</IonLabel>

          <div className="input__container input__container--type-text">
            <InputFactory
              type="text"
              value={formData?.miscellaneous?.google_analytics_measurement_id}
              name="miscellaneous.google_analytics_measurement_id"
              placeholder={t("gaMeasurementId")}
              onIonChange={updateFormData}
              error={errors?.miscellaneous?.google_analytics_measurement_id}
              className={"input__input input-factory__input input-factory__input--type-text"}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
